import React from 'react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';
import { AccountNameColumn } from './columns/health-check/account-name';
import { FailedCheckPointsColumn } from './columns/health-check/failed-check-points';
import { StatusColumn } from './columns/health-check/status';
import { SpendColumn } from './columns/health-check/spend';
import { BudgetInSearchColumn } from './columns/health-check/budget-in-search';
import { SpendInSearchColumn } from './columns/health-check/spend-in-search';
import { BudgetInAudienceAndPMaxColumn } from './columns/health-check/budget-in-audience-pmax';
import { SpendInAudienceAndPMaxColumn } from './columns/health-check/spend-in-audience-pmax';

const bindOnRenderHeader = (column) => {
  if (column.onRenderHeader) {
    return column;
  }

  const onRenderHeader = columnProps => (
    <div>
      <span className="grid-header-text">
        {columnProps.column.name}
      </span>
      {columnProps.column.helpTopic && <HelpIcon topic={columnProps.column.helpTopic} />}
    </div>
  );

  return {
    ...column,
    onRenderHeader,
  };
};

export const buildHealthCheckGridColumns = ({ i18n }) => [
  AccountNameColumn({ i18n }),
  FailedCheckPointsColumn({ i18n }),
  StatusColumn({ i18n }),
  SpendColumn({ i18n }),
  BudgetInSearchColumn({ i18n }),
  SpendInSearchColumn({ i18n }),
  BudgetInAudienceAndPMaxColumn({ i18n }),
  SpendInAudienceAndPMaxColumn({ i18n }),
].map(bindOnRenderHeader);
